import { render, staticRenderFns } from "./EditCollectionEvent.vue?vue&type=template&id=d34cb15a"
import script from "./EditCollectionEvent.vue?vue&type=script&lang=js"
export * from "./EditCollectionEvent.vue?vue&type=script&lang=js"
import style0 from "./EditCollectionEvent.vue?vue&type=style&index=0&id=d34cb15a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports